// extracted by mini-css-extract-plugin
export default {"errorPageRoot":"ErrorPageRouter_errorPageRoot__TPG9l"};